<template>
    <div class="space-y-5">
        <div
            v-if="hasCertification"
            :style="{
                'background-color': player.headerColor,
                'border-left-color': player.borderColor,
                color: player.headingColor,
            }"
            class="flex-shrink-0 w-full p-3 space-y-3 rounded-lg"
        >
            <div class="px-3 py-1.5 flex items-center justify-between space-x-2 text-base">
                <p class="font-medium">{{ $t("r_player.certificate.course_status") }}</p>

                <p class="opacity-80">{{ progress }}%</p>
                <p v-if="false" class="flex items-center space-x-1 ct-text-success">
                    <span>{{ $t("r_player.certificate.completed") }}</span>
                    <TrophyIcon class="w-4 h-4" />
                </p>
            </div>
            <div class="px-3 pb-2">
                <button
                    @click="showCertificateModal = true"
                    v-if="showCertificate"
                    :style="{ 'background-color': player.mainColor }"
                    class="w-full flex items-center justify-center space-x-2 px-3 py-2 rounded-lg border border-transparent text-sm font-medium text-white hover:opacity-80"
                >
                    <TrophyIcon class="w-4 h-4" />
                    <span>{{ $t("r_player.certificate.certificate_link") }}</span>
                </button>
                <div v-else class="flex items-center space-x-2">
                    <div
                        class="relative h-2 w-full ct-bg-3 rounded-full overflow-hidden"
                        :style="{ 'background-color': player.backColor }"
                    >
                        <div
                            class="absolute h-full top-0 left-0 bg-gray-900 dark:bg-white rounded-full"
                            :style="{ width: `${progress}%`, 'background-color': player.mainColor }"
                        ></div>
                    </div>
                    <TrophyIcon class="w-4 h-4" />
                </div>
            </div>
        </div>
        <div
            :style="{
                'background-color': player.headerColor,
                'border-left-color': player.borderColor,
            }"
            class="flex-shrink-0 w-full p-3 space-y-3 rounded-lg"
        >
            <div
                :style="{
                    color: player.headingColor,
                }"
                class="flex items-center py-1.5 px-3 space-x-2 text-base"
            >
                <div class="flex-grow">
                    <cUtilsEdit @edit="goToLayoutField('playerSideTitle')">
                        <p class="font-medium">
                            {{ player.sideTitle }}
                        </p>
                    </cUtilsEdit>
                </div>

                <p v-if="!hasCertification" class="opacity-80">{{ progress }}%</p>
            </div>
            <div class="space-y-2 pb-2">
                <SidebarSection
                    v-for="(section, index) in filesGroupedIntoSections"
                    :key="index"
                    :section="section"
                />
            </div>
        </div>
        <CertificateModal
            v-if="showCertificate"
            v-model="showCertificateModal"
            :playerUuid="player.uuid"
            :certificateUuid="certificate.uuid"
        />
    </div>
</template>

<script>
import { TrophyIcon } from "@easy/ui/icons";
import { mapGetters, mapState } from "vuex";
import SidebarSection from "./SidebarSection.vue";
import { PLAYER_FILE_TYPES } from "@/apps/player/services/players.service";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { issuedCertificateEvents } from "@/views/tools/player/services/issued-certificate.event";
import { RENDER_ROUTE_NAMES } from "@/views/render/render.routes";
import CertificateModal from "@/views/tools/player/certificate/CertificateModal.vue";

export default {
    name: "PlayerSidebar",
    components: { SidebarSection, cUtilsEdit, TrophyIcon, CertificateModal },
    setup() {
        const { goToLayoutField } = usePlayerGoTo();
        return { goToLayoutField };
    },
    mounted() {
        this.eventSource = issuedCertificateEvents.subscribeToEvent(
            this.player.uuid,
            ({ payload, type }) => {
                this.certificate = payload;
                if (type === issuedCertificateEvents.EVENTS.GRANTED) {
                    this.showCertificateModal = true;
                }
                this.eventSource?.close();
            }
        );
    },
    beforeUnmount() {
        this.eventSource?.close();
    },
    data() {
        return {
            RENDER_ROUTE_NAMES,
            certificate: null,
            showCertificateModal: false,
        };
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        ...mapState("player/view", ["player", "watched"]),
        ...mapGetters("player/view", ["noHeadersFiles"]),
        releasedFiles() {
            if (this.preview) {
                return this.noHeadersFiles;
            }
            const now = new Date();
            return this.noHeadersFiles.filter(
                (file) =>
                    !(file.releaseAt && new Date(file.releaseAt) > now && !file.showBeforeRelease)
            );
        },
        watchedFiles() {
            return this.releasedFiles.filter((file) => this.watched.indexOf(file.id) !== -1);
        },
        progress() {
            return Math.round(100 * (this.watchedFiles.length / this.releasedFiles.length));
        },
        filesGroupedIntoSections() {
            const grouped = this.player.files.reduce((acc, file) => {
                if (file.type === PLAYER_FILE_TYPES.header && !file._deleted && !file.hide) {
                    acc.push({ header: file, files: [] });
                } else {
                    if (acc.length > 0) {
                        acc[acc.length - 1].files.push(file);
                    } else {
                        acc.push({ header: {}, files: [file] });
                    }
                }
                return acc;
            }, []);
            return grouped;
        },
        showCertificate() {
            return Boolean(this.certificate?.uuid);
        },
        hasCertification() {
            const certificate = this.player.certificate;
            //either has active certification or already issued certificate
            return (certificate && certificate.id && certificate.isActive) || this.showCertificate;
        },
    },
};
</script>
